<template>
  <div>
    <v-dialog
      width="633"
      content-class="add-head-modal"
      v-model="deleteModalComp"
    >
      <v-card class="pt-11 pb-13 px-8 rounded-xl elevation-0 bg_sidebar">
        <v-row>
          <v-col cols="12">
            <p class="font-20px dark-color--text">{{ $t("Tariffs.end") }}</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <p class="font-16px mb-3">
                {{ $t("Tariffs.end_desc[0]") }}
                <br><br>
                {{ $t("Tariffs.end_desc[1]") }}
                <br>
                {{ $t("Tariffs.end_desc[2]") }}
            </p>  
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              @click="openModal"
              class="button elevation-0 px-10"
              color="sub white--text"
            >{{ $t("Tariffs.end") }}</v-btn>
            <v-btn
              @click="navigateChange"
              class="button elevation-0 px-10 ml-2"
              color="main_color white--text"
            >{{ $t("Tariffs.change_tariff") }}</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="finishModal" width="677" content-class="add-head-modal">
      <v-card
        class="pt-11 pb-13 px-8 rounded-xl elevation-0 bg_sidebar success"
      >
        <p class="font-20px">{{ $t("Tariffs.sure_want_end") }}</p>
        <v-row>
            <v-col cols="12" class="py-0">
                <p class="font-18px sub--text mb-3 mt-8">{{ $t("Owners.tariff_info") }}</p>
            </v-col>
            <v-col cols="6">
                <v-row>
                    <v-col md="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Owners.tariff_name") }}:</span>
                    </v-col>
                    <v-col md="6" class="py-2"> 
                        <span class="dark-color--text font-16px" v-if="myTariffInfo.tariff" v-text="myTariffInfo.tariff.name"></span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Default.status") }}:</span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="dark-color--text font-16px" v-text="myTariffInfo.status === 'accepted' ? $t('Default.accepted') : $t('Default.not_accepted')"></span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Default.period") }}:</span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="dark-color--text font-16px" v-text="myTariffInfo.period == 'monthly' ? $t('Default.monthly') : $t('Default.yearly')"></span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Default.cost") }}:</span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="dark-color--text font-16px" v-if="myTariffInfo.price" v-text="myTariffInfo.price.toLocaleString('KZ-kz') + ' KZT'"></span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Owners.date_expires") }}:</span>
                    </v-col>
                    <v-col md="6" class="py-2">
                        <span class="dark-color--text font-16px" v-text="dayjs(myTariffInfo.end_date).format('DD/MM/YYYY')"></span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row>
                    <v-col cols="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Organization.organizations") }}:</span>
                    </v-col>
                    <v-col cols="6" class="py-2">
                        <p class="dark-color--text font-16px mb-3" v-for="(item) in myTariffInfo.companies" :key="item.id" v-text="item.name"></p>
                    </v-col>
                    <v-col cols="6" class="py-2">
                        <span class="sub--text font-16px">{{ $t("Owners.employees_count") }}:</span>
                    </v-col>
                    <v-col cols="6" class="py-2">
                        <span class="dark-color--text font-16px" v-text="myTariffInfo.employees_ratio"></span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
                <p class="font-18px sub--text mb-5 mt-8">{{ $t("Tariffs.cancel_detail") }}</p>  
            </v-col>
            <v-col cols="12" class="py-0">
                <p class="font-16px dark_color--text">{{ $t("Tariffs.money_back") }}</p>
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn
                    @click="closeModal"
                    class="button elevation-0 px-10"
                    color="sub white--text"
                >{{ $t("Default.back") }}</v-btn>
                <v-btn
                    @click="deleteTariff"
                    class="button elevation-0 px-10 ml-1"
                    color="main_color white--text"
                >{{ $t("Tariffs.end") }}</v-btn>
            </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { computed, ref } from "@vue/composition-api";
import { useStore } from "vuex-composition-helpers";
import {
  MutationTypes,
  DispatchTypes,
  GettersTypes,
} from "@/store/modules/admin/tariffs/types";

export default {
  name: "getReasonEditModal",
  props: {
    deleteModal: Boolean,
    tariff_info: Object 
  },
  setup(props, context) {
    const dayjs = require("dayjs");
    require("dayjs/locale/ru");
    const store = useStore();
    const checked = ref(null);

    const finishModal = ref(false);

    const forms = ref({});

    const deleteModalComp = computed({
      get(){
        return props.deleteModal;
      },
      set(value) {
        return context.emit('close', value);
      }
    });

    const navigateChange = () => {
        context.root.$router.push('/tariffs/change');
    };

    const openModal = () => {
        deleteModalComp.value = false;
        finishModal.value = true;
    };

    const closeModal = () => {
        finishModal.value = false;
        deleteModalComp.value = true;
    };

    const deleteTariff = async () => {
      try{
        alert('no endpoint!');
      }
      catch(e) {
        console.log(e);
      }
    };

    return {
      store,
      forms,
      checked,
      deleteModalComp,
      myTariffInfo: props.tariff_info,
      deleteTariff, 
      finishModal, 
      openModal,
      dayjs, 
      closeModal, 
      navigateChange
    };
  },
};
</script>

<style scoped>
.success {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.align-center {
  text-align: center;
  margin-bottom: 27px;
}
</style>
